
// -------------------------------------------------------
// Paths
// -------------------------------------------------------

export const IFRAME_ORIGIN = '//player.ceskatelevize.cz'; // for video
export const ASSETS_FOLDER =
  process.env.NODE_ENV !== 'production' ? '' : '/cms/dukla61-en/';

// -------------------------------------------------------
// Sizes + Move
// -------------------------------------------------------

export const COMPACT_LIMIT = 800;
export const SCENE_BASE = {
  WIDTH: 2300,
  HEIGHT: 1040,
};
export const VIDEO_RATIO = {
  W: 1440,
  H: 810,
};
export const HEAD_HEIGHT = 63;
export const MOVE_Y = 0.05; // move offset in %
export const MOVE_SCENE_Y = 0.5; // scene move slide in %
export const VIDEO_CENTER_OFFSET = 0.5;
export const TIMELINE_SHOW_OFFSET = 120;
export const TIMELINE_SHOW_LIMIT = 0.3; // limit for timeline to show in video mode
export const SOUND_ATMO = {
  LIMIT: 0.3,
  CENTER: 0.5,
};

// -------------------------------------------------------
// Actions
// -------------------------------------------------------

export const ACTIONS = {
  SET_SCENE_VIDEO: 'SET_SCENE_VIDEO',
  SET_HOVERED_SPOT: 'SET_HOVERED_SPOT',
  SET_HILITE_ID: 'SET_HILITE_ID',
  SET_SUBPAGE: 'SET_SUBPAGE',
  SET_SUB_SECTION: 'SET_SUB_SECTION',
  SET_COMPACT_VIDEO: 'SET_COMPACT_VIDEO',
  SET_FULLSCREEN: 'SET_FULLSCREEN',
  VIDEO_COMPLETE: 'VIDEO_COMPLETE',
  SOUND_BLOCKED: 'SOUND_BLOCKED',
  RESIZE: 'RESIZE',
};

// -------------------------------------------------------
// UI
// -------------------------------------------------------

export const SUB_PAGE = {
  MEMORIAL: 'MEMORIAL',
  INFO: 'INFO',
};

export const SUB_SECTION = {
  INTRO: 'INTRO',
  OUTRO: 'OUTRO',
};



// WEBPACK FOOTER //
// ./src/constants.js